import { Toolbar } from 'primereact/toolbar';
import { MonitoringFilter } from '../components/Monitoring/MonitoringFilter';
import { BreadCrumb } from 'primereact/breadcrumb';
import AssessmentHistoryTables from '../components/AssessmentHistory/AssessmentHistoryTables';
import { useNavigate } from 'react-router-dom';
import { Suspense } from 'react';
import { useAppSelector } from '../redux/hooks';
import { selectedReportsFilter } from '../redux/reducers/filterReportsSlice';
import { selectUser } from '../redux/reducers/userSlice';
import { CustomBranding, mapCustomBranding } from '../models/User';
import { useSideNavActive } from '../components/LayoutWrapper/SideNavLayoutContext';

/* Commenting out to hide non-functional UI until we have time to complete this work in future sprints */
// import AssessmentHistoryQuickStats from '../components/AssessmentHistory/AssessmentHistoryQuickStats';

const AssessmentHistory = () => {
  const reportsFilterRedux = useAppSelector(selectedReportsFilter);
  const userRedux = useAppSelector(selectUser);
  const miamiBrand =
    userRedux?.network?.customBranding &&
    mapCustomBranding[userRedux?.network?.customBranding] === CustomBranding.MIAMI;
  const navigate = useNavigate();
  const sideNavActive = useSideNavActive();
  const breadcrumbItems = [
    { label: 'Monitor', command: () => navigate('/quick-data') },
    { label: miamiBrand ? 'Skill Challenge History' : 'Assessment History' },
  ];
  const home = { icon: 'nc_icon-nc_home icon-sm', command: () => navigate('/') };

  const classSelected = reportsFilterRedux.classes.length > 0;

  return (
    <div className="grid nc_content-frame nc_page-inner">
      {!sideNavActive && (
        <>
          <Toolbar
            role="section"
            className="col-10 col-offset-1 nc_page-header"
            center={<h1>{miamiBrand ? 'Skill Challenge History' : 'Assessment History'}</h1>}
          />
          <BreadCrumb className="col-10 col-offset-1" model={breadcrumbItems} home={home} />
        </>
      )}
      <div className="col-10 col-offset-1 flex flex-column align-items-center">
        <Suspense>
          <MonitoringFilter />
        </Suspense>
      </div>

      {classSelected ? (
        <>
          <div className="col-10 col-offset-1 flex flex-column align-items-center">
            <AssessmentHistoryTables miamiBrand={miamiBrand as boolean} />
          </div>
        </>
      ) : (
        <div className="col-10 col-offset-1 flex flex-column align-items-center">
          <h3 className="text-center">Please use the Report Settings above to get started!</h3>
        </div>
      )}
    </div>
  );
};

export default AssessmentHistory;
